import { helper } from '@ember/component/helper';

export function prependYear([item]) {
  if (!isNaN(item) && /^[0-9]+$/.test(item)) {
    return `Year ${item}`;
  }
  return item;
}

export default helper(prependYear);
